export const magmaSequential: string[] = [];
export const magmaSequentialMixed: string[] = [];
